module.exports = __webpack_public_path__ + "media/images/new_landing/logos/ceskasporitelna-f4414321f9f7b49c5eb3a598019d1ee3.png";